import type { Market } from '@ts-internal/shared-lib';
export const defaultSearchQuery = '';
export const defaultPageNumber = 1;
export const defaultPageSize = 20;
export const defaultRoleTitles = [];
export const defaultLocations = [];

export const enabledMarkets = [
  'AU',
  'NZ',
  'HK',
  'ID',
  'MY',
  'PH',
  'SG',
  'TH',
] as Market[];
